import { useDispatch, useSelector } from 'react-redux';
import Maps from './components/inquery/Maps';
import { DataContainer } from './components/DataContainer';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { restart, setBrand } from './store/inquerySlice';
import { BRANDS, DEFAULT_BRAND } from './brands';

function Inquery() {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();

    // The embedding site tells us which company the form belongs to:
    //   abuss.ee    -> /inquery            (default)
    //   triobuss    -> /inquery?brand=triobuss
    const brandParam = searchParams.get('brand');
    const brand = BRANDS[brandParam] ? brandParam : DEFAULT_BRAND;
    useEffect(() => { dispatch(setBrand({ brand })); }, [brand, dispatch]);

    const sent = useSelector((state) => state.inquery.sent);

    if(sent) return (

        <div className="width100 g32 p32 column center-main center-cross" style={{ height: '100vh' }}>
            <h1 className="title">Täname!</h1>
            <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_604_139)"><circle cx="32" cy="32" r="32" fill="#65D190"/><path d="M9.37259 32.0001L15.0294 26.3432L26.3432 37.6569L48.9706 15.0295L54.6274 20.6864L26.3432 48.9707L9.37259 32.0001Z" fill="white"/></g><defs><clipPath id="clip0_604_139"><rect width="64" height="64" fill="white"/></clipPath></defs></svg>
            <p style={{ textAlign: 'center' }}>Esimene samm õnnestunud reisi suunas on astutud. Nüüd natuke kannatust ja peagi saabub hinnapakkumine Teie postkasti.</p>
            <button onClick={() => dispatch(restart())}>Alusta uut päringut</button>
        </div>

    ); else return (
        <DataContainer actionType={'inquery/postQuery'}>
            <Maps/>
        </DataContainer>

    );
}

export default Inquery;